import { useRouter } from "found";
import * as React from "react";
import { createFragmentContainer } from "react-relay";

// web-app-nav imports
import { webAppNavFragments } from "./WebAppNav.gql";
import { styles } from "./WebAppNav.styles";
import { IContainer, IProps } from "./WebAppNavTypes";

// components
import { LogoHorizontal } from "#webapp/src/components/logo";
import { WebAppNavAvatarMenu } from "./web-app-nav-avatar-menu";

// state

// util
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { useEcosystem } from "@clockwise/web-commons/src/util/ecosystem";

// constants
import { paths } from "#webapp/src/constants/site.constant";

// material-ui
import { Menu } from "@clockwise/design-system/icons";
import { EcosystemEnum } from "@clockwise/schema";
import { IconButton, Tooltip } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { browserName, CustomView } from "react-device-detect";
import { ExtensionDownloadButton } from "../extension-download-button";

///////////////
// Component //
///////////////

const WebAppNavCmpt = (props: IProps) => {
  const { classes } = props;

  const { router } = useRouter();
  const ecosystem = useEcosystem();

  const onClickLogo = () => {
    track(TrackingEvents.APP_NAV.LOGO);
    router.push(paths.webApp);
  };

  const isChrome = browserName === "Chrome";
  const isFF = browserName === "Firefox";

  return (
    <div className={classes.container}>
      <div className={classes.absoluteContainer}>
        <div className={classes.gradientBar} />
        <div className={classes.rowFlexedContainer}>
          {props.onClickMenu && (
            <Tooltip title="Menu">
              <IconButton style={{ marginRight: 12 }} onClick={props.onClickMenu}>
                <Menu />
              </IconButton>
            </Tooltip>
          )}
          {!props.hideLogo ? (
            <>
              <div className={classes.logoContainer} onClick={onClickLogo}>
                <LogoHorizontal style={{ width: 172 }} />
              </div>
            </>
          ) : null}
          <div>{props.children}</div>
          {!props.hideMenu ? (
            <div className={classes.logout}>
              <WebAppNavAvatarMenu
                viewer={props.viewer}
                hideAdvancedMenu={props.hideAdvancedMenu}
                shouldNavigate
              />
            </div>
          ) : (
            <CustomView condition={(isChrome || isFF) && ecosystem === EcosystemEnum.Google}>
              <div className="cw-justify-self-end -cw-mt-2">
                <ExtensionDownloadButton
                  browserName={isChrome ? "Chrome" : "Firefox"}
                  size="medium"
                />
              </div>
            </CustomView>
          )}
        </div>
      </div>
    </div>
  );
};

WebAppNavCmpt.defaultProps = {
  hideAdvancedMenu: false,
  hideLogo: false,
};

/////////////////
// With Styles //
/////////////////

const WebAppNavStyled = withStyles(styles)(WebAppNavCmpt);

///////////
// Relay //
///////////

export const WebAppNav = createFragmentContainer<IContainer>(WebAppNavStyled, webAppNavFragments);
